import axios from "axios";
import { ACCESSORS } from "./components/ImportItems/CsvDataTable";
import ImportItems from "./components/ImportItems";

const API_DOMAIN = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN || 'http://localhost:3001';

export interface SearchResults {
  members: any[];
  users: any[];
  accounts: [];
  evidence: any[];
}

export type CustomFieldData = {
  description: string;
  name: string;
  searcherKey: string;
  type: string;
  dataAccessor: string;
};

export const getSettingsForAccount = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        API_DOMAIN + "/settings/");
      resolve(response.data.account);
    } catch (e) {
      reject(e);
    }
  });
};

export const getActivityLogs = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        API_DOMAIN + `/evidences/${id}/activity-logs`);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const listMembers = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        API_DOMAIN + "/users/list");
      resolve(response.data.users);
    } catch (e) {
      reject(e);
    }
  });
};

export const listOwners = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        API_DOMAIN + "/users/listOwners");
      resolve(response.data.users);
    } catch (e) {
      reject(e);
    }
  });
};

export const listTeams = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/teams/list");
      resolve(response.data.teams);
    } catch (e) {
      reject(e);
    }
  });
};

// export const getIntegrations = (auth0: any) => {
//   return new Promise<any>(async (resolve, reject) => {
//     try {
//       const config = await getAuthHeaders(auth0);
//       const response = await axios.get(
//         window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/integrations/list",
//         config
//       );
//       resolve(response.data.integrations);
//     } catch (e) {
//       reject(e);
//     }
//   });
// };

// export const fetchIntegration = (auth0: any, type: string) => {
//   return new Promise<any>(async (resolve, reject) => {
//     try {
//       const config = await getAuthHeaders(auth0);
//       const response = await axios.get(
//         `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/integrations/${type}`,
//         config
//       );
//       resolve(response.data.integration);
//     } catch (e) {
//       reject(e);
//     }
//   });
// };

// export const createToken = (auth0: any, type: string, accountId: string) => {
//   return new Promise<any>(async (resolve, reject) => {
//     try {
//       const config = await getAuthHeaders(auth0);
//       const response = await axios.post(
//         `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/integrations/${type}/createToken`,
//         { accountId }, // Pass accountId in the body
//         config
//       );
//       resolve(response.data); // Token creation response
//     } catch (e) {
//       reject(e);
//     }
//   });
// };

export const createAPIToken = (auth0: any, name: string) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/settings/token/api`,
        { name }, // Pass name in the body
      );
      resolve(response.data); // Token creation response
    } catch (e) {
      reject(e);
    }
  });
};

export const updateObjectsStatusFields = (auth0: any, body: any, id: string) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.put(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/fields/deliveryStatus/${id}`,
        body);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const updateStatusLinkDisplayToggle = (auth0: any, value: boolean) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.put(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + '/fields/statusLinkDisplayToggle',
        { overwriteIdeaStatusWithLinkedDelivery: value });
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const updateValidation = (auth0: any, params: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const {id,verifyState, validationCount } = params
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/ideas/updateValidation`,
        {id, verifyState, validationCount});
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const listTokens = (auth0: any, type: string) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/settings/token/${type}`);
      resolve(response.data.tokenDoc);
    } catch (e) {
      reject(e);
    }
  });
};

export const listSlackChannels = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/integrations/channel-list");
      resolve(response.data.channels);
    } catch (e) {
      reject(e);
    }
  });
};

export const listSolutions = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/solutions/list");
      resolve(response.data.solutions);
    } catch (e) {
      reject(e);
    }
  });
};

export const listCompanies = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/companies/list");
      resolve(response.data.companies);
    } catch (e) {
      reject(e);
    }
  });
};

export const listOpTypes = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/fields/opType");
      resolve(response.data.opTypes);
    } catch (e) {
      reject(e);
    }
  });
};

export const listFields = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/fields/list");
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const listFieldCustomizations = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/fields/fieldCustomizations");
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

// Get Domains
export const getDomains = async (auth0: any) => {
  try {
    const response = await axios.get(`${API_DOMAIN}/fields/domain`);
    return response.data.domains;
  } catch (e: any) {
    console.error("Error getting domains:", e);
    throw e;
  }
};

export const listObjectsFields = (type: "priority" | "status", auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/fields/list/${type}`);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const updateObjectsFields = (auth0: any, id: string, body: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.put(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/fields/${id}`,
        body);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const deleteOptionAndReassign = (
  auth0: any,
  id: string,
  type: "status" | "priority" | "component",
  oldKey: string,
  newKey: string,
  options: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.put(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          `/fields/${id}/reassign-tags`,
        { type, oldKey, newKey, options });
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const listRequests = (
  params: { oldestFirst: boolean; filter: { ownerIds: string[] } },
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/requests/list",
        params);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const dismissSuggested = (
  auth0: any,
  matchId: string,
  ideaId: string,
  textOrRequestId: string,
  textType: boolean
  
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/ideas/dismissSuggested",
        { matchId, ideaId, textOrRequestId, textType });
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const dismissFeedback = (
  requestId: string,
  rejectInfo: { reason: string; comment: string },
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/ideas/dismissRequest",
        { requestId, rejectInfo });
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const getIdea = (id: string) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/" + id;
      const response = await axios.get(url);
      resolve(response.data.idea);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getDiscoveryIdea = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/discovery/" + id;
      const response = await axios.get(url);
      resolve(response.data.idea);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getRecentQueries = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/recent-queries";
      const response = await axios.get(url);
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getIdeaRequests = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/" +
        id +
        "/requests";
      const response = await axios.get(url);
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getSubIdeas = (ideaId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ai-agent/ideas/" +
        ideaId +
        "/sub-ideas";
      const response = await axios.get(url);
      resolve(response.data?.subIdeas ?? response.data ?? []);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};


/**
 * Links sub-idea to parent theme / removes consumed theme on the server.
 * PUT /ideas/:ideaId/sub-idea — body includes themeTitle and subIdeaId.
 */
export const updateTheme = async (
  ideaId: string,
  title: string,
  auth0: any,
  activeFilters?: string
): Promise<any> => {
  try {
    const url =  window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/ai-agent/ideas/${ideaId}/theme`;

    const response = await axios.put(
      url,
      { title, ...(activeFilters ? { activeFilters: activeFilters } : {}) });
    return response.data;
  } catch (e: any) {
    console.error("Error linking sub-idea to theme:", e);
    throw e;
  }
};

/**
 * Attaches an existing top-level idea as a sub-idea under a parent idea.
 * PUT /ai-agent/ideas/:parentIdeaId/sub-idea — body: { subIdeaId }
 */
export const attachExistingIdeaAsSubIdea = async (
  parentIdeaId: string,
  subIdeaId: string,
  auth0: any
) => {
  const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN
    + `/ai-agent/ideas/${parentIdeaId}/sub-idea`;
  const response = await axios.put(url, { subIdeaId });
  return response.data;
};

export const getUnreadNotificationsCount = (id: string) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/" +
        id +
        "/requestsUnreadNotificationsCount";
      const response = await axios.get(url);
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};


export const getIdeaMatches = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/" +
        id +
        "/matches";
      const response = await axios.get(url);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const getCustomerEvidence = async (
  id: string,
  auth0: any,
) => {
  try {
    const url =
      window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
      "/orgs/" +
      id +
      "/accountEvidence";
    const response = await axios.get(url);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getSingleCustomerEvidence = async (
  id: string,
) => {
  try {
    const url =
      window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
      "/orgs/" +
      id +
      "/sideBarEvidence";
    const response = await axios.get(url);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getCustomersEvidence = async (
  orgIds: string[],
  auth0: any,
) => {
  try {
    const url =
    window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/orgs/customersEvidence";
    const response = await axios.post(url, { orgIds });
    
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getCustomersEvidencesView = async (
  orgIds: string[],
  filters: any[],
  sort: { [name: string]: 1 | -1 },
  search: string,
  auth0: any,
) => {
  try {
    const url =
    window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/orgs/customersEvidenceData";
    const response = await axios.post(url, { orgIds, filters, sort, search});
    
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const saveCustomer360Views = async (
  userId: string,
  orgIds: string[],
  viewType: string,
  auth0: any,
) => {
  try {
    const url =
    window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/orgs/saveCustomer360Views";
    const response = await axios.post(url, { orgIds, userId, viewType });
    
    return response.data;
  } catch (e) {
    throw e;
  }
};



export const getRequestMatches = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/requests/" +
        id +
        "/matches";
      const response = await axios.get(url);
      resolve(response.data.matches);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getMatchesForRequests = async (evidenceIds: Array<string>, auth0: any) => {
  try {
    const url =
      window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
      "/matches";
    const response = await axios.post(url, {evidenceIds});
    return response.data.matches;
  } catch (e: any) {
    console.error("Error fetching matches:", e);
  }
};

export const getIdeaMatchesForEvidence = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/matches/" +
        id +
        "/matches";
      const response = await axios.get(url);
      resolve(response.data.matches);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const saveIdea = (idea: any, auth0: any) => {

  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/update";
      const response = await axios.post(url, { idea });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const updateDuplicateIdea = (ideaId: any, auth0: any) => {

  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/ideas/${ideaId}/mark-as-not-duplicate`;
      const response = await axios.put(url, { markedAsNotDuplicate: true });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};


export const addRequestsToIdea = (
  auth0: any,
  ideaId: string,
  request: any,
  matchId?: boolean
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/addRequestsToIdea";
      const response = await axios.post(
        url,
        { ideaId, request, matchId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const addGroupedRequestsToIdea = (
  auth0: any,
  ideaId: string,
  container: any,
  children: any[],
  matchId?: boolean
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/addGroupedRequestsToIdea";
      const response = await axios.post(
        url,
        { ideaId, container, children, matchId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const attachRequestToIdea = (
  ideaId: string,
  conversationId: string,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/" +
        ideaId +
        "/attach";
      const response = await axios.post(url, { conversationId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const detachRequest = (
  ideaId: string,
  requestId: string,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/" +
        ideaId +
        "/detach";
      const response = await axios.post(url, { requestId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const validateRequest = (
  auth0: any,
  requestId: string,
  ideaId?: string,
  matchId?: string
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/validateRequest";
      const response = await axios.post(url, { requestId, ideaId, matchId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const ideaValidation = (
  auth0: any,
  idea_id?: string
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = window.__RUNTIME_CONFIG__.REACT_APP_MLAPI_DOMAIN + `/idea_validation/${idea_id}`;
      const response = await axios.post(url, {"max": "1"});
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const validateMatch = (
  auth0: any,
  matchId: string,
  ideaId: string,
  request: any,
  textId?: string
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      if (!(ideaId?.length > 0 && matchId?.length > 0)) {
        return reject("Invalid ideaId or matchId");
      }
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/validateMatch";
      const response = await axios.post(
        url,
        { matchId, ideaId, textId, request });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const deleteIdea = (ideaId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/" + ideaId;
      const response = await axios.delete(url);
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const deleteGeneratedIdea = (ideaId: string, deleteInfo:  {reason: string, comment: string }, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/generated/delete/" + ideaId;
      const response = await axios.put(
        url,
        deleteInfo);
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const addCommentToIdea = (
  ideaId: string,
  comment: string,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/ideas/comment`;
      const response = await axios.post(
        url,
        { ideaId, comment: { text: comment } });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const addCommentToRequest = (
  ideaId: string,
  requestId: string,
  comment: string,
  usersMentioned: {
    _id: string;
    name: string;
  }[],
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/requests/comment`;
      const response = await axios.post(
        url,
        { ideaId, requestId, comment: { text: comment, usersMentioned } });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const updateRequestComment = (
  commentId: string,
  comment: string,
  usersMentioned: {
    _id: string;
    name: string;
  }[],
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/requests/comment/${commentId}`;
      const response = await axios.post(
        url,
        { commentId, comment: { text: comment, usersMentioned } });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const deleteCommentFromRequest = (
  ideaId: string,
  commentId: string,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/requests/comment/${commentId}/delete`;
      const response = await axios.post(url, { ideaId, commentId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getSolution = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/solutions/" + id;
      const response = await axios.get(url);
      resolve(response.data.solution);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getDuplicateIdea = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/ideas/${id}/duplicate-idea`;
      const response = await axios.get(url);
      resolve(response.data.idea);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getSolutionCategories = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/solutions/categories";
      const response = await axios.get(url);
      resolve(response.data.categories);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const filterSolutions = (filters: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/solutions/filter";
      const response = await axios.post(url, { filters });
      resolve(response.data.solutions);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const createNewIdea = (
  { idea, request, productItemId, requestsToReAssign }: any,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas";
      const response = await axios.post(
        url,
        { idea, request, productItemId, requestsToReAssign });
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const convertIdeaDiscovery = (fields: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/ideas/discovery`;
      const response = await axios.post(url, {fields} );
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const assignRequestToNewIdea = (
  { idea, evidence, productItemId }: any,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/assignRequestToNewIdea";
      const response = await axios.post(
        url,
        { idea, evidence, productItemId });
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const assignEvidencesToNewIdea = (
  { idea, evidences }: any,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/assign-evidences-to-new-idea";
      const response = await axios.post(
        url,
        { idea, evidences });
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const removeGtmIdeaId = (
  id : any,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/ideas/removeGtmIdeaId/${id}`;
      const response = await axios.put(
        url,
        id);
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getFilteredIdeas = (
  filters: any,
  sort: { [name: string]: 1 | -1 },
  limit: number,
  skip: number,
  tabName: string,
  auth0: any,
  archived: boolean
) => {
  return new Promise<{ totalCount: number; ideas: any[] }>(

    async (resolve, reject) => {

      try {
        const url =
          window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/ideas/filters_query";
        const response = await axios.post(
          url,
          { filters, sort, limit, skip, tabName, archived });
        resolve(response.data);
      } catch (e: any) {
        console.log(e);
        reject(e);
      }
    }
  );
};

export const saveIdeaStarred = (idea: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/starred";
      const response = await axios.post(url, { idea });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const saveRequestStarred = (idea: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/requests/starred";
      const response = await axios.post(url, { idea });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const markEvidencePending = (evidence: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    const isUserPushRequired = evidence.isUserPushRequired
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/evidences/${evidence.id}/toggle-pending`;
      const response = await axios.patch(url, { isUserPushRequired });
      resolve(response);
    } catch (e: any) {
      console.error(`Failed to ${isUserPushRequired ? 'mark' : 'unmark' } evidence as pending`, e);
      reject(e);
    }
  });
};

export const getSolutionMatches = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/solutions/" +
        id +
        "/matches";
      const response = await axios.get(url);
      resolve(response.data.matches);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const saveSolution = (solution: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/solutions/update";
      const response = await axios.post(url, { solution });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const saveRequest = (request: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/requests/update";
      const response = await axios.post(url, { request });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const saveStarred = (solution: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/solutions/starred";
      const response = await axios.post(url, { solution });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const saveUpvote = (solution: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/solutions/upvote";
      const response = await axios.post(url, { solution });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const deleteSolution = (solutionId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/solutions/" +
        solutionId;
      const response = await axios.delete(url);
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const deleteToken = (auth0: any, tokenId: string)  => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/settings/token/${tokenId}`;
      const response = await axios.delete(url);
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchIdeas = (
  params: { query: string; onlyMyIdeas ?: string; excludeParentIdeas ?: boolean },
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/ideas",
        params);
      const data = response.data;
      const ideas = Array.isArray(data)
        ? data
        : (data?.ideas ?? data?.results ?? []);
      resolve(Array.isArray(ideas) ? ideas : []);
    } catch (e) {
      reject(e);
    }
  });
};

export type IdeaDeliveryStatusBatchItem = {
  ideaId: string;
  status: string;
  linkedProductItemId?: string;
  productItem?: {
    status?: string;
    link?: string;
    origin?: string;
    itemKey?: string;
  };
};

export const fetchIdeaDeliveryStatusByIds = (
  ideaIds: string[],
  auth0: any
): Promise<IdeaDeliveryStatusBatchItem[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/ideas/delivery-status-by-ids`,
        { ideaIds });
      resolve(response.data?.items ?? []);
    } catch (e) {
      reject(e);
    }
  });
};

export const searchAll = (query: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/search?query=" +
          query);
      resolve(response.data.results);
    } catch (e) {
      reject(e);
    }
  });
};


export const searchOpportunityNiv = (query: string ,auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.put(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/search/opportunityNIV?query=" ,
        query);
      resolve(response.data.results);
    } catch (e) {
      reject(e);
    }
  });
};

export const searchEvidences = (query: string ,auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.put(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/search/evidences" ,
        {query : query});
      resolve(response.data.evidences);
    } catch (e) {
      reject(e);
    }
  });
};

export const saveSettings = (settings: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/settings/";
      const response = await axios.post(url, { settings });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const saveDomains = (
  data: { domain: string; push: boolean },
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/settings/domains";
      const response = await axios.post(url, { data });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const updateCategory = (category: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/settings/categories?operation=update";
      const response = await axios.post(url, { ...category });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const insertCategory = (category: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/settings/categories?operation=insert";
      const response = await axios.post(url, { ...category });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const deleteCategory = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        `/settings/categories/${id}`;
      const response = await axios.delete(url);
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getOrganization = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/companies/" + id;
      const response = await axios.get(url);
      resolve(response.data.company);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getOrganizationItems = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/companies/" +
        id +
        "/matches";
      const response = await axios.get(url);
      resolve(response.data.matches);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getClusterTickets = (clusterId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/clusters/" +
        clusterId;
      const response = await axios.get(url);
      resolve(response.data.tickets);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchUsers = (query: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/users";
      const response = await axios.post(url, { query });
      resolve(response.data.users);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchAdmins = (query: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/admins";
      const response = await axios.post(url, { query });
      resolve(response.data.admins);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchMembers = (query: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/members";
      const response = await axios.post(url, { query });
      resolve(response.data.members);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchOrgs = (
  { query }: { query: string },
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/orgs";
      const response = await axios.post(url, { query });
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchOrgsWithEvidencesAndCxItems = (
  { query }: { query: string },
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/orgsWithEvidencesAndCxItems";
      const response = await axios.post(url, { query });
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const fetchCustomers = (
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/customers";
      const response = await axios.post(url);
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchSelectedOrgs = (
  { query, ids, page = 1, limit = 15 }: { 
    query: string; 
    ids?: string[]; 
    page?: number; 
    limit?: number; 
  },
  auth0: any
) => {
  return new Promise<{
    accounts: any[];
    totalCount: number;
    hasMore: boolean;
    currentPage: number;
  }>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/searchSelectedOrgs";
      const response = await axios.post(url, { query, ids, page, limit });
      
      // Handle both old and new API response formats
      if (response.data.accounts) {
        // New paginated response format
        resolve({
          accounts: response.data.accounts || [],
          totalCount: response.data.totalCount || 0,
          hasMore: response.data.hasMore || false,
          currentPage: response.data.currentPage || page,
        });
      } else {
        // Legacy response format (array of accounts)
        const accounts = Array.isArray(response.data) ? response.data : [];
        resolve({
          accounts,
          totalCount: accounts.length,
          hasMore: false,
          currentPage: 1,
        });
      }
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchSubmitters = (
  { query, ids, page = 1, limit = 15 }: {
    query: string;
    ids?: string[];
    page?: number;
    limit?: number;
  },
  auth0: any
) => {
  return new Promise<{
    submitters: any[];
    totalCount: number;
    hasMore: boolean;
    currentPage: number;
  }>(async (resolve, reject) => {
    try {
      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/search/searchSubmitters";
      const response = await axios.post(url, { query, ids, page, limit });
      resolve({
        submitters: response.data.submitters || [],
        totalCount: response.data.totalCount || 0,
        hasMore: response.data.hasMore || false,
        currentPage: response.data.currentPage || page,
      });
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};


export const getSuggestionsForIdea = (
  title: string,
  text: string,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_MLAPI_DOMAIN + "/suggestions/idea";
      const response = await axios.post(
        url,
        { title, description: text });
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getAllTickets = (
  type: string,
  page: number,
  pageSize: number,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/conversations/list?type=${type}&page=${page}&pageSize=${pageSize}`;
      const response = await axios.get(url);
      resolve(response.data.conversations);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const updateTicketLabeling = (
  auth0: any,
  ticketId: string,
  ticketType: string,
  highlighted?: string[],
  blocks?: any[]
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/conversations/update`;
      const response = await axios.post(
        url,
        { ticketId, ticketType, highlighted, blocks });
      resolve(response.data.success);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const verifyEmail = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/users/verifyEmail`;
      const response = await axios.post(url, {});
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const inviteUser = (
  auth0: any,
  user: { name: string; email: string; role: string }
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/users/invite`;
      const response = await axios.post(url, { user });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getTopIdeasReport = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/top-ideas";
      const response = await axios.get(url);

      resolve(response.data.ideas);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const createTeam = (team: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/teams";
      const response = await axios.post(url, { team });
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getViews = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/views/get");
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

// src/Api.ts

export const getThemes = (ideaId: string, activeFilters: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/ai-agent/idea/themes`;
      const response = await axios.post(url, {ideaId, activeFilters});
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const addViews = (body: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/ideas/views/add";
      const response = await axios.post(url, body);
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const deleteTeam = (teamId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/teams/" + teamId;
      const response = await axios.delete(url);
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const saveMember = (teamId: string, memberId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/teams/addMember";
      const response = await axios.post(url, { teamId, memberId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const deleteMember = (teamId: string, memberId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/teams/deleteMember";
      const response = await axios.post(url, { teamId, memberId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const canEditTeamIds = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/fields/canEditTeamIds");
      resolve(response.data.customizations);
    } catch (e) {
      reject(e);
    }
  });
};

export const listNotifications = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/users/notifications");
      resolve(response.data.notifications);
    } catch (e) {
      reject(e);
    }
  });
};

export const markNotificationsRead = (auth0: any, id = '', mode: string) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/users/markNotificationsRead",
        {id: id, mode: mode});
      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
};

export const markItemNotificationsRead = (itemId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/users/markItemNotificationsRead",
        {itemId});
      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
};

export const updateMember = (user: any, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/users/update";
      const response = await axios.post(url, { user });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const reassignRequest = (
  auth0: any,
  ideaId: string,
  evidenceId: string,
  isGap?: boolean,
  matchId?: string,
  isMatchRelevant?: boolean
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/reassignRequest";
      const response = await axios.post(url, { evidenceId , ideaId, isGap , matchId, isMatchRelevant });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const searchProductItems = (type: string, query: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/search/product-items",
        { query, type });
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const linkToProductItem = (
  ideaId: string,
  productItemId: string,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/linkToProductItem";
      const response = await axios.post(url, { productItemId, ideaId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const unLinkToProductItem = (
  ideaId: string,
  productItemId: string,
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/unLinkToProductItem";
      const response = await axios.post(url, { productItemId, ideaId });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getRequest = (requestId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/requests/${requestId}`);
      resolve(response.data?.request);
    } catch (e) {
      reject(e);
    }
  });
};

export const getCommentsForRequest = (requestId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/requests/${requestId}/comments`);
      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
};

export const validateData = (
  auth0: any,
  data: {
    userEmails?: string[];
    sfIds?: string[];
    oppIds?: string[];
    domainsComponents?: {
      [key: string]: string;
    }[];
  }
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {

      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/import/validate`;
      const response = await axios.post(url, data);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const runImport = (auth0: any, data: { rows: any[] }) => {
  return new Promise<any>(async (resolve, reject) => {
    try {

      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/import`;
      const response = await axios.post(url, data);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const runImportEvidence = (auth0: any, data: { rows: any[] }) => {
  return new Promise<any>(async (resolve, reject) => {
    try {

      const url = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/import/evidence`;
      const response = await axios.post(url, data);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const getIdeasExportData = (
  auth0: any,
  data: { dates: any }
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        `/import/ideasExportData`;
      const response = await axios.post(url, data, {timeout: 300000});
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const getEvidencesExportData = (
  auth0: any,
  data: { dates: [Date | null, Date | null] }
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        `/import/requestsExportData`;
      const response = await axios.post(url, data, {timeout: 300000});
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const getIdeaPageDisplay = (type: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          `/fields/display/${type}`);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const updateIdeaPageDisplay = (
  body: { value: string; use: boolean },
  auth0: any
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.put(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/fields/display/update",
        body);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const getRelatedCxItem = (itemId: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/cx-items/${itemId}`;
      const response = await axios.get(url);
      resolve(response?.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getRequestsMatchesForAnIdea = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/ideas/" +
        id +
        "/requestsMatches";
      const response = await axios.get(url);
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getEvidenceURL = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
        "/requests/" +
        id +
        "/evidence";
      const response = await axios.get(url);
      resolve(response.data.evidence);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const labelMatch = (matchId: string, ideaId: string, textId: string, sameRequest: boolean ,auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/matches/label";
      const response = await axios.post(url, { matchId, ideaId, textId, sameRequest });
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

// Get customizations property init
export const getCustomizationsPropertyInit = (auth0: any): Promise<any> => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customizations/property_init`;
      const response = await axios.get(url);
      resolve(response.data);
    } catch (e: any) {
      console.error(e);
      reject(e);
    }
  });
};

/**
 * Adds a new property to the "idea" customization.
 * 
 * @param auth0 - Auth0 instance for authentication
 * @param property - Property object to add
 * @returns A promise resolving to the API response
 */
export const addProperty = async (auth0: any, property: any): Promise<any> => {
  try {
    const token = await auth0.getAccessTokenSilently();
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customizations/properties`;
    const response = await axios.post(url, property, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error adding property:", error);
    throw error;
  }
};

/**
 * Updates an existing property in the "idea" customization.
 * 
 * @param auth0 - Auth0 instance for authentication
 * @param propertyName - Name of the property to update
 * @param updatedProperty - Updated property object
 * @returns A promise resolving to the API response
 */
export const updateProperty = async (
  auth0: any,
  propertyName: string,
  updatedProperty: any
): Promise<any> => {
  try {
    const token = await auth0.getAccessTokenSilently();
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customizations/properties/${propertyName}`;
    const response = await axios.put(url, updatedProperty, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error updating property:", error);
    throw error;
  }
};

/**
 * Deletes a property from the "idea" customization.
 * 
 * @param auth0 - Auth0 instance for authentication
 * @param propertyName - Name of the property to delete
 * @returns A promise resolving to the API response
 */
export const deleteProperty = async (
  auth0: any,
  propertyName: string
): Promise<any> => {
  try {
    const token = await auth0.getAccessTokenSilently();
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customizations/properties/${propertyName}`;
    const response = await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error deleting property:", error);
    throw error;
  }
};


/**
 * runs Aggregations for all ideas.
 * 
 * @param auth0 - Auth0 instance for authentication
 * @returns A promise resolving to the API response
 */
export const runAggregations = async (
  auth0: any,
): Promise<any> => {
  try {
    const token = await auth0.getAccessTokenSilently();
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/admin/runAggregations`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error deleting property:", error);
    throw error;
  }
};


export const fetchCustomersFor360 = (
  text: string,
  activeFilters: any[],
  auth0: any,
  skip = 0,
  limit = 50
) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.post(
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN +
          "/orgs/customers",
        { text, activeFilters, skip, limit });
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const fetchConfigFor360 = (auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/orgs/config`;
      const response = await axios.get(url);
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const fetchSingleCustomerData = async (
  orgId: string,
  auth0: any
) => {
  try {
    const url =
      window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/customer360/singleCustomerData";
    const response = await axios.post(url, { orgId: orgId });
    return response.data;
  } catch (e) {
    throw e;
  }
};

// Customer 360 V2 API methods
export const fetchEvidencesPaginated = async (
  request: {
    filters: any[];
    search?: string;
    sortBy: string;
    sortDirection: 'asc' | 'desc';
    skip: number;
    limit: number;
    requiredFields: string[];
    evidenceInclusion?: 'assigned' | 'suggested' | 'total';
  },
  auth0: any
) => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/evidences/paginated`;
    const response = await axios.post(url, request);
    return response.data;
  } catch (e: any) {
    console.error('Error fetching paginated evidences:', e);
    throw e;
  }
};

export const requestCustomer360Export = async (
  request: {
    filters: any[];
    search?: string;
    sortBy: string;
    sortDirection: 'asc' | 'desc';
    requiredFields: string[];
    evidenceInclusion?: 'assigned' | 'suggested' | 'total';
  },
  auth0: any
) => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/evidences/export`;
    const response = await axios.post(url, request);
    return response.data;
  } catch (e: any) {
    console.error('Error requesting Customer 360 export:', e);
    throw e;
  }
};

export const fetchCustomer360ExportHistory = async (
  filters: any[],
  auth0: any
): Promise<Array<{ _id: string; status: string; createdAt: string; processedAt?: string; error?: string }>> => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/evidences/export/history`;
    const response = await axios.post(url, { filters });
    return response.data;
  } catch (e: any) {
    console.error('Error fetching Customer 360 export history:', e);
    throw e;
  }
};

export const fetchGroupStructure = async (
  request: {
    filters: any[];
    groupBy: 'domainId' | 'componentId' | 'status' | 'priority' | 'demand';
    search?: string;
    customerSearch?: string;
    evidenceInclusion?: 'assigned' | 'suggested' | 'total';
  }
) => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/groups/structure`;
    const response = await axios.post(url, request);
    return response.data;
  } catch (e: any) {
    console.error('Error fetching group structure:', e);
    throw e;
  }
};

export const fetchGroupItems = async (
  groupValue: string,
  request: {
    filters: any[];
    groupBy: string;
    sortBy: string;
    sortDirection: 'asc' | 'desc';
    search?: string;
    skip: number;
    limit: number;
    evidenceInclusion?: 'assigned' | 'suggested' | 'total';
  },
  auth0: any
) => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/groups/${encodeURIComponent(groupValue)}/items`;
    const response = await axios.post(url, request);
    return response.data;
  } catch (e: any) {
    console.error('Error fetching group items:', e);
    throw e;
  }
};

export const fetchGroupAggregates = async (
  groupValue: string,
  request: {
    filters: any[];
    groupBy: string;
    evidenceInclusion?: 'assigned' | 'suggested' | 'total';
  },
  auth0: any
) => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/groups/${encodeURIComponent(groupValue)}/aggregates`;
    const response = await axios.post(url, request);
    return response.data;
  } catch (e: any) {
    console.error('Error fetching group aggregates:', e);
    throw e;
  }
};

export const fetchCalculateAggregations = async (
  request: {
    ideaIds: string[];
    filters: any[];
    evidenceInclusion?: 'assigned' | 'suggested' | 'total';
  },
  auth0: any
) => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/calculate-aggregations`;
    const response = await axios.post(url, request);
    return response.data;
  } catch (e: any) {
    console.error('Error calculating aggregations:', e);
    throw e;
  }
};

export const fetchGroupsAggregatesBatch = async (
  request: {
    groupBy: string;
    groupValues: string[];
    filters: any[];
    evidenceInclusion?: 'assigned' | 'suggested' | 'total';
  },
  auth0: any
) => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/groups/aggregates/batch`;
    const response = await axios.post(url, request);
    return response.data;
  } catch (e: any) {
    console.error('Error fetching groups aggregates batch:', e);
    throw e;
  }
};

export const getIdeaActivityLogs = (id: string, auth0: any) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/ideas/idea-activity-logs/${id}`;
      const response = await axios.get(url);
      resolve(response.data);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const getLatestEvidenceLog = (auth0: any, evidenceId: string) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/evidences/${evidenceId}/latest-evidence-log`);
      resolve(response.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const fetchIdeaEvidences = async (
  ideaId: string,
  request: {
    filters: any[];
    evidenceInclusion?: 'assigned' | 'suggested' | 'total';
  },
  auth0: any
) => {
  try {
    const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/customer360/evidences/${ideaId}`;
    const response = await axios.post(url, request);
    return response.data;
  } catch (e: any) {
    console.error('Error fetching group structure:', e);
    throw e;
  }
};

export const getEvidence = async (
  evidenceId: string,
  auth0: any
): Promise<any> => {
  try {

    const url = `${API_DOMAIN}/evidences/${evidenceId}`;
    const response = await axios.get(url);
    return response.data?.evidence;
  } catch (e) {
    throw e;
  }
};

export const handleMergeTwoIdeas = (ideaId: string, auth0: any) => {
  
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/ideas/${ideaId}/merge`;
      const response = await axios.post(url, ideaId );
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};

export const handleMergeIdeasFromIdids = (ideaIds: string[], auth0: any) => {
  
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url =
        window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + `/ideas/merge`;
      const response = await axios.post(url, ideaIds );
      resolve(response);
    } catch (e: any) {
      console.log(e);
      reject(e);
    }
  });
};
